import React, { useState } from 'react';
import styled, { css, keyframes } from 'styled-components';
import { goToTop } from '_helpers';
import { _ } from '_locales';
import { webCampaignBaseUrl } from '_apis';
import { connect } from 'react-redux';
import { colors } from '_styles';
import events from '../events';
import eventTracker from '../../../helpers/eventTracker';

const OpacityAnimation = keyframes`
  from {opacity: 0};
  to {opacity: 1}
`;

const Container = styled.div`
  box-sizing: border-box;
  animation: ${OpacityAnimation} 0.7s;
  background-color: white;
  padding-bottom: 10px;
  border-radius: 10px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
`;

const Title = styled.h2`
  font-size: 18px !important;
  color: rgba(64, 64, 64, 1);
  font-weight: bold !important;
  border-bottom: 2px solid #E7ECEF;
  padding-bottom: 10px;
  padding-top: 13px;
  padding-left: 10px;
`;

const Topic = styled.h3`
  font-size: 18px !important;
  font-weight: bold !important;
  color: rgba(64, 64, 64, 1);
  margin-bottom: 0;
  cursor: pointer;

  h1, h2, h3, h4, h5, h6, b, strong{
    font-weight: bold !important;
  }
`;

const Description = styled.p`
  color: rgba(64, 64, 64, 1);
  font-size: 16px !important;
  line-height: 1.4em;
  font-weight: 500 !important;

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4; /* number of lines to show */
  line-clamp: 4;
  -webkit-box-orient: vertical;
`;

const LearnMoreButton = styled.button`
  padding: 9px 12px;
  font-size: 13px !important;
  margin-left: auto;
  border-radius: 4px;
  font-weight: 500 !important;
  text-transform: capitalize;
  background-color: #187bc1;
  color: white;
  margin-top: auto;
  text-decoration: none !important;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  transition: all .3s;
  border: 1px solid transparent;
  cursor: pointer;

  &:hover {
    border: 1px solid ${colors.LIGHT_BLUE};
    background-color: #fff;
    color: ${colors.LIGHT_BLUE};
    box-shadow: rgba(99, 99, 99, 0.2) 0px 1px 4px 0px;
    opacity: 0.9;
  }
`;

const ResourcesBox = styled.div`
  display: flex;
  padding: 10px 20px 0px 10px;
  box-sizing: border-box;
`;

const CampaignBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 100% !important;
`;

const CampaignImage = styled.img`
  margin-left: auto !important;
  margin-right: 20px !important;
  height: 200px;
  object-fit: cover;
  object-position: 50% 50%;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 1px 4px 0px;
`;

const Campaign = ({
  setShowCampignIframe,
  campaigns
}) => {
  const learnMoreClickHandler = () => {
    setShowCampignIframe(true);
    goToTop();
    eventTracker(events.HOME_SCREEN_FEATURED_LESSON_CTA_TAP, '');
  };

  return (
    <Container>
      <Title>
        {_('education.featured_lesson')}
      </Title>
      <ResourcesBox>
        <CampaignImage
          src={`https://cdn.recyclecoach.com/campaigns/${campaigns.campaign_cover}`}
          alt={campaigns.campaign_nm}
        />
        <CampaignBox>
          <Topic onClick={learnMoreClickHandler}>
            {campaigns.campaign_nm}
          </Topic>
          <Description>
            {campaigns.notes}
          </Description>
          <LearnMoreButton
            onClick={learnMoreClickHandler}
          >
            {_('homePage.learn_more')}
          </LearnMoreButton>
        </CampaignBox>
      </ResourcesBox>
    </Container>
  );
};

export default connect(
  (store) => ({
    projectId: store.plugin.projectId,
    districtId: store.config.districtId,
    uuid: store.plugin.uuid,
    selectedLang: store.config.selectedLang,
    campaigns: store.education.campaigns
  })
)(Campaign);
